// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 774) return "static/chunks/framework-eede84a156dceb7b5dae.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "d15d9d71072694b7945a" + ".js";
};